import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useHistory, useParams } from 'react-router-dom'
import ReactLoader from 'react-loader'
import { BACKEND_URL_PREFIX, OKIN_OPTIONS } from '../../../../utils/const'
import { buildDefaultHeaders } from '../../../../actions/helper'
import { useSelector } from 'react-redux'

import Header from '../Structure/Header'
import ResultsTable from './ResultsTable'

const OutcomesCompliance = () => {
  const history = useHistory()
  const { id } = useParams()
  const state = useSelector(state => state)

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('outcomes_compliance')

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/epcr/outcomes_compliance/${id}`,
        buildDefaultHeaders({ auth: state.auth })
      )

      if (response.ok) {
        const result = await response.json()
        setData(result)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [id])

  const goBack = () => {
    history.push('/dashboard_new/edu_prog')
  }

  const { program_name, accordance, okin_id } = data || {}

  return (
    <div className={styles.outcomesWrap}>
      <Header
        title={program_name}
        levelStudy={OKIN_OPTIONS.find(item => item.value === okin_id)?.label}
        onBack={goBack}
        accordance={accordance}
        general={null}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <ReactLoader loaded={!loading} color='#5b76e5'>
        {data && (
          <ResultsTable data={data.data} />
        )}
      </ReactLoader>
    </div>
  )
}

export default OutcomesCompliance
